import { render, staticRenderFns } from "./TextAreaFormPart.vue?vue&type=template&id=99441b94&scoped=true"
import script from "./TextAreaFormPart.vue?vue&type=script&lang=js"
export * from "./TextAreaFormPart.vue?vue&type=script&lang=js"
import style0 from "./TextAreaFormPart.vue?vue&type=style&index=0&id=99441b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99441b94",
  null
  
)

export default component.exports